import * as angular from 'angular';

angular.module('GorillaBoy')
    .controller('migrateDataModalCtrl', [
        '$rootScope',
        '$scope',
        '$log',
        '$translate',
        '$uibModalInstance',
        '$window',
        function migrateDataModalCtrl($rootScope: ng.IRootScopeService, $scope: ng.IScope, $log: ng.ILogService, $translate, $uibModalInstance, $window) {
            // Initialization
            $scope.handleSubmit = () => {
                $rootScope.acknowledgeMigrationAndUpdatePreference();
                $uibModalInstance.dismiss();
            }
        }
    ]);